var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLayoutAdvanced3DOnly = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 29,
  height: 18,
  viewBox: "0 0 29 18",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 27,
  height: 16.2,
  fill: "#263A71",
  fillRule: "evenodd",
  stroke: "currentColor",
  rx: 2,
  transform: "translate(1 1)"
})));
export { SvgLayoutAdvanced3DOnly as ReactComponent };
export default __webpack_public_path__ + "assets/images/layout-advanced-3d-only.svg";